//@ts-check
import React from 'react';
import SubscriptionsPage from './SubscriptionsPage';

var SubscriptionsBootstrap = function SubscriptionsBootstrap(_ref) {
  var children = _ref.children,
      history = _ref.history,
      subscriptionsPath = _ref.subscriptionsPath;
  if (!history) return children;
  var location = history.location;
  if (typeof location.pathname !== 'string') return children;

  if (location.pathname.startsWith(subscriptionsPath)) {
    return React.createElement(SubscriptionsPage, {
      history: history,
      subscriptionsPath: subscriptionsPath
    });
  }

  return children;
};

SubscriptionsBootstrap.defaultProps = {
  subscriptionsPath: '/settings/subscriptions'
};
export default SubscriptionsBootstrap;